import { render, staticRenderFns } from "./StudentProgression.vue?vue&type=template&id=456be2e0&scoped=true"
import script from "./StudentProgression.vue?vue&type=script&lang=js"
export * from "./StudentProgression.vue?vue&type=script&lang=js"
import style0 from "./StudentProgression.vue?vue&type=style&index=0&id=456be2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456be2e0",
  null
  
)

export default component.exports